import {useCallback,useEffect,useState} from 'react';
import {QRCodeSVG} from 'qrcode.react';
import {Copy,QrCode,ArrowRight,X} from 'lucide-react';
import {toast} from 'sonner';
import {api,message} from '../lib/api';
import {Btn,SelectField,Modal,ErrorNotice,Tag} from './shared';

const inviteUrl = token => window.location.origin + '/coach-invite/' + token;

export const CoachInviteDialog = ({open, onClose, players}) => {
  const [athleteId,setAthleteId]=useState(players[0]?.id||'');
  const [invites,setInvites]=useState([]);
  const [token,setToken]=useState('');
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const load=useCallback(()=>{
    if(!athleteId)return;
    api.get(`/athletes/${athleteId}/coach-invites`).then(r=>setInvites(r.data)).catch(e=>setError(message(e)));
  },[athleteId]);
  useEffect(()=>{setToken('');setError('');load();},[load]);

  const create=async()=>{
    setBusy(true);setError('');
    try{
      const r=await api.post(`/athletes/${athleteId}/coach-invites`,{athlete_id:athleteId});
      setToken(r.data.token);load();
    }catch(e){setError(message(e));}finally{setBusy(false);}
  };
  const revoke=async id=>{
    try{await api.post(`/athletes/${athleteId}/coach-invites/${id}/revoke`);toast.success('Invitation closed');setToken('');load();}
    catch(e){toast.error(message(e));}
  };
  const copy=async()=>{
    try{await navigator.clipboard.writeText(inviteUrl(token));toast.success('Invitation link copied');}
    catch{toast.error('Copy the link shown below instead.');}
  };

  return <Modal open={open} onClose={onClose} id="coach-invite-modal" closeTestId="coach-invite-modal-close"
    title="Invite your coach" description="Show the QR code in person, or send the link. Your coach signs up and lands connected to your player.">
    <div className="form-stack">
      <SelectField label="Player" id="coach-invite-player-select" value={athleteId} onChange={e=>setAthleteId(e.target.value)}>
        {players.map(p=><option value={p.id} key={p.id}>{p.name}</option>)}
      </SelectField>
      {token ? <div className="qr-panel" data-testid="coach-invite-qr-panel">
        <QRCodeSVG value={inviteUrl(token)} size={196} level="M" data-testid="coach-invite-qr-code" />
        <p className="share-url" data-testid="coach-invite-url">{inviteUrl(token)}</p>
        <Btn data-testid="coach-invite-copy-button" onClick={copy}><Copy />Copy invitation link</Btn>
        <p className="form-hint">Valid for 14 days. Only share it with your player’s coach.</p>
      </div> : <>
        <ErrorNotice text={error} />
        <Btn data-testid="coach-invite-create-button" disabled={busy||!athleteId} onClick={create}>{busy?'Creating…':'Create invitation & QR code'}<QrCode /></Btn>
      </>}
      {invites.length>0 && <div className="coach-invite-list" data-testid="coach-invite-list">
        <strong>Invitations for this player</strong>
        {invites.map(invite=><div className="coach-invite-row" data-testid={'coach-invite-row-'+invite.id} key={invite.id}>
          <Tag tone={invite.status==='accepted'?'green':invite.status==='pending'?'cyan':''} data-testid={'coach-invite-status-'+invite.id}>{invite.status}</Tag>
          <span>{invite.status==='accepted'?`Accepted by ${invite.accepted_coach_name||'a coach'}`:`Expires ${new Date(invite.expires_at).toLocaleDateString('en-US',{month:'short',day:'numeric'})}`}</span>
          {invite.status==='pending'&&<button className="icon-btn" aria-label="Close invitation" data-testid={'coach-invite-revoke-'+invite.id} onClick={()=>revoke(invite.id)}><X size={15} /></button>}
        </div>)}
      </div>}
      {token&&<div className="form-actions"><Btn secondary data-testid="coach-invite-new-button" onClick={()=>setToken('')}>Create another<ArrowRight /></Btn></div>}
    </div>
  </Modal>;
};
